export const accessibilityStatementLink = {
  key: 'accessibilityStatementLink',
  name: 'Accessibility Statement Link',
  siteIdentifier: 'global',

  accessibilityStatementLinkButton: 'Accessibility Statement',
};
